import script from "./list-booking-history.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-booking-history.vue?vue&type=script&setup=true&lang=ts"

import "./list-booking-history.vue?vue&type=style&index=0&id=7ffc23d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ffc23d0"]])

export default __exports__